import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { AppButton, AppDivider, AppLoader, AppParagraph, AppSegment } from '..'

type Props = {
  id?: string
  children: ReactNode
  data?: { count: number; data: unknown[] }
  title?: string
  isLoading?: boolean
  isFetching?: boolean
  noItemsMsg?: string
  pageSize?: number
  activePage?: number
  onPageChange?: (pageNo: number) => void
}

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

const AppList = ({
  id,
  children,
  data = { count: 0, data: [] },
  title,
  isLoading,
  isFetching,
  noItemsMsg,
  pageSize,
}: Props) => {
  const { t } = useTranslation()

  const displayNoItemsInfo = !isLoading && !isFetching && !data.data.length
  const displayScrollTopBtn = pageSize !== undefined && data?.data?.length >= pageSize / 2
  const displayLoader = isLoading || isFetching

  return (
    <div id={id} data-testid="app-list">
      <AppSegment
        headerProps={{ id: `${id}-header` || undefined, text: title }}
        marginBottom={false}
      >
        <AppLoader active={displayLoader}>
          {children}
          {displayNoItemsInfo && (
            <AppParagraph
              text={noItemsMsg || t('common.info.nothingToDisplay')}
              size="medium"
              centered
            />
          )}
          {displayScrollTopBtn && (
            <>
              <AppDivider size="large" />
              <AppButton
                variant="outlined"
                iconName="ANGLE_DOUBLE_UP"
                position="center"
                onClick={scrollToTop}
                dataTestId="scroll-top-btn"
                aria-label="Scroll top button"
              />
            </>
          )}
        </AppLoader>
      </AppSegment>
    </div>
  )
}

export default AppList
